// local components
import { ChangeVehicleFooterInterstate } from '../changeVehicleFooter/ChangeVehicleFooter.interstate';
import { ChangeVehicleHeaderInterstate } from '../changeVehicleHeader/ChangeVehicleHeader.interstate';

// store
import SearchAndSelectVehicle from './SearchAndSelectVehicle';

// context
import { VehicleSearchFiltersContextProvider } from './VehicleSearchFiltersContext';

// types
import type { IVehicle, VehicleObjectForSimilaritySearch } from '@makemydeal/dr-platform-types';

export type ChangeVehicleInterstateProps = {
    enableConfirmModal?: boolean;
    forceSmallBreakpoint?: boolean;
    isInsideSlideOut?: boolean;
    /** Set by hosts whose cancel returns to an offer in progress — the footer's button then reads "Return to Offer". */
    showReturnToOffer?: boolean;
    onCancel?: () => void;
    /** When set, Change reports the pick here instead of applying it to the deal. */
    onVehicleSelected?: (vehicle: IVehicle) => void;
    similaritySearchVehicleOverride?: VehicleObjectForSimilaritySearch;
};

const ChangeVehicleInterstate = ({
    enableConfirmModal,
    forceSmallBreakpoint,
    isInsideSlideOut,
    showReturnToOffer,
    onCancel,
    onVehicleSelected,
    similaritySearchVehicleOverride
}: ChangeVehicleInterstateProps) => {
    const containerClassName = isInsideSlideOut
        ? 'change-vehicle-container change-vehicle-container--slideout'
        : 'change-vehicle-container';

    return (
        <VehicleSearchFiltersContextProvider
            isInsideSlideOut={isInsideSlideOut}
            forceSmallBreakpoint={forceSmallBreakpoint}
            similaritySearchVehicleOverride={similaritySearchVehicleOverride}
        >
            <div className={containerClassName}>
                <ChangeVehicleHeaderInterstate isInsideSlideOut={isInsideSlideOut} />
                <SearchAndSelectVehicle />
                <ChangeVehicleFooterInterstate
                    enableConfirmModal={enableConfirmModal}
                    isInsideSlideOut={isInsideSlideOut}
                    showReturnToOffer={showReturnToOffer}
                    onCancel={onCancel}
                    onVehicleSelected={onVehicleSelected}
                />
            </div>
        </VehicleSearchFiltersContextProvider>
    );
};

export default ChangeVehicleInterstate;
